/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from './http-client'

export class ApiPaymentChannelController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-payment-channel-controller
   * @name GetOrganisationPaymentChannels
   * @request GET:/api/v1/payments/channels
   */
  getOrganisationPaymentChannels = (params: RequestParams = {}) =>
    this.http.request<
      (
        | 'UNKNOWN'
        | 'WISE'
        | 'KLARNA_OB_SEPA'
        | 'KLARNA_OB_SEPA_INSTANT'
        | 'MOCK'
        | 'WALLET'
        | 'SEPA_FILE'
        | 'MANUAL'
        | 'PAYMENT_SKIPPED'
        | 'EXTERNAL_DIRECT_DEBIT'
        | 'N_A'
      )[],
      any
    >({
      path: `/v1/payments/channels`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getOrganisationPaymentChannelsPath = '/v1/payments/channels'
  static getOrganisationPaymentChannelsMethod = 'GET'
}
